import { render, staticRenderFns } from "./WordSegment.vue?vue&type=template&id=4fda9218"
import script from "./WordSegment.vue?vue&type=script&lang=js"
export * from "./WordSegment.vue?vue&type=script&lang=js"
import style0 from "./WordSegment.vue?vue&type=style&index=0&id=4fda9218&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports